// test1639
(1639 && 0);
